// Description: Component that render the current Page of the configurations page
// Updated: 20/08/2025
// Author: Simon Franklin

// React
import React from 'react';

// Material UI Components
import { Box } from '@mui/material';

// Render The Component
const SubPage = ({ page }) => {
  return (
    <Box
      sx={{
        padding: { xs: '20px', sm: '49px 94px' },
        display: 'flex',
        flexDirection: 'column',
        gap: '45px',
        width: '100%',
        flex: '1',
        maxHeight: { xs: 'calc(100vh - 197.8px)', sm: 'auto' },
        overflowY: { xs: 'auto', sm: 'unset' },
        backgroundColor: { xs: '#fff', sm: 'unset' }
      }}
    >
      {page}
    </Box>
  );
}

export default SubPage;
